const KEY_PREFIX = "bbp_vendor_pending_scans";

function keyFor(vendorId) {
  return `${KEY_PREFIX}:${vendorId || "unknown"}`;
}

export function loadPendingScans(vendorId) {
  try {
    const raw = localStorage.getItem(keyFor(vendorId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function savePendingScans(vendorId, rows) {
  localStorage.setItem(keyFor(vendorId), JSON.stringify(rows || []));
}

export function pushPendingScan(vendorId, row) {
  const current = loadPendingScans(vendorId);
  const next = [row, ...current].slice(0, 200);
  savePendingScans(vendorId, next);
  return next;
}

export function removePendingScan(vendorId, requestId) {
  const next = loadPendingScans(vendorId).filter((row) => row.request_id !== requestId);
  savePendingScans(vendorId, next);
  return next;
}

export function clearPendingScans(vendorId) {
  localStorage.removeItem(keyFor(vendorId));
}
